import React, { useEffect, useState } from "react";
import AddMeeting from "./AddMeeting";
import EditMeeting from "./EditMeeting";
import { FaEdit } from "react-icons/fa";
import { useGetMeetingsMutation } from "../EditDataSources/EditDataSourceSlice";
const tabsArray = [
  { label: "All", value: "all" },
  { label: "Create", value: "create" },
];

export default function Meeting() {
  const [tabValue, setTabValue] = useState("all");
  console.log(tabValue);
  const [getMeetings, { data, isError, error, isLoading, isSuccess }] =
    useGetMeetingsMutation();
  useEffect(() => {
    getMeetings({
      databaseID: "67f8d94fd87ed27dc5b2b305",
      limit: 100,
    });
  }, []);
  if (isLoading) {
    console.log("loading");
  }
  if (isError) {
    console.log(error);
  }
  if (isSuccess) {
    console.log(data);
  }
  const meetingArray = [
    {
      Visit_ID: 0,
      Meeting_category: "old business",
      Owner_Name: "parag",
      Whom_To_Visit: "Mittal's Industry",
      check_in_time: "2025-04-11T16:09",
      Subject: "To Increase The Goods Quality",
    },
    {
      Visit_ID: 1,
      Meeting_category: "old business",
      Owner_Name: "parag",
      Whom_To_Visit: "Sharma Transpostation",
      check_in_time: "2025-04-11T16:10",
      Subject: "To ensure everthing is going smooth ",
    },
    {
      Visit_ID: 2,
      Meeting_category: "new business",
      Owner_Name: "parag",
      Whom_To_Visit: "Ranjeet Books",
      check_in_time: "2025-04-11T16:10",
      Subject: "New Business Meeting",
    },
  ];
  const [selectedItem, setSelectedItem] = useState(null);
  console.log(selectedItem);
  console.log(selectedItem && tabValue === "edit" ? "hi" : null);

  return (
    <main className="w-full h-[94vh] flex flex-col items-start justify-center p-2 gap-2">
      <section className="w-full flex items-center justify-between">
        <h1 className="font-medium">Meeting</h1>
        <div className="w-full flex items-center justify-end gap-2">
          {tabsArray.map((tab) => (
            <button
              key={tab.value}
              onClick={() => setTabValue(tab.value)}
              className={`border rounded border-blue-950 py-[2px] px-2 ${
                tabValue === tab.value
                  ? "text-white bg-blue-950"
                  : "text-black bg-white"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </section>
      <hr className="border border-blue-950 w-full" />
      {tabValue === "all" ? (
        <section className="w-full flex flex-col gap-1 h-[86vh] border-gray-300 border pt-2">
          <div className="overflow-auto w-full h-full">
            <table className="border-none w-full">
              <thead className="sticky top-0 bg-white z-10">
                <tr>
                  <th className="border-b text-left px-2">Meeting_category</th>
                  <th className="border-b text-left px-2">Owner_Name</th>
                  <th className="border-b text-left px-2">Whom_To_Visit</th>
                  <th className="border-b text-left px-2">check_in_time</th>
                  <th className="border-b text-left px-2">Subject</th>
                  <th className="border-b text-left px-2">Edit</th>
                </tr>
              </thead>
              <tbody>
                {data !== undefined &&
                  Array.isArray(data["data"]) &&
                  data["data"].length > 0 &&
                  data["data"].map((row, index) => (
                    <tr
                      key={index}
                      className={`${index % 2 === 0 ? "bg-gray-100" : ""}`}
                      onDoubleClick={() => {
                        setSelectedItem(row.Visit_ID);
                        setTabValue("edit");
                      }}
                    >
                      <td className="border-b text-left px-2 my-2">
                        {row.Meeting_category}
                      </td>
                      <td className="border-b text-left px-2 my-2">
                        {row.Owner_Name}
                      </td>
                      <td className="border-b text-left px-2 my-2">
                        {row.Whom_To_Visit}
                      </td>
                      <td className="border-b text-left px-2 my-2">
                        {row.check_in_time}
                      </td>
                      <td className="border-b text-left px-2 my-2">
                        {row.Subject}
                      </td>
                      <td
                        className="border-b text-center px-2 my-2 cursor-pointer"
                        onClick={() => {
                          setSelectedItem(row.Visit_ID);
                          setTabValue("edit");
                        }}
                      >
                        <FaEdit />
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </section>
      ) : null}
      {tabValue === "create" ? <AddMeeting setTabValue={setTabValue} /> : null}
      {selectedItem && tabValue === "edit" ? (
        <EditMeeting
          meetingObject={
            data !== undefined &&
            Array.isArray(data["data"]) &&
            data["data"].length > 0
              ? data["data"].find((item) => item.Visit_ID === selectedItem)
              : null
          }
          setTabValue={setTabValue}
        />
      ) : null}
    </main>
  );
}
